<div class="login-wrapper">

  <form class="login-card" (ngSubmit)="submit()" *ngIf="!done">

    <h2>{{ t('setNewPasswordTitle') }}</h2>

    <input
      [(ngModel)]="newPassword"
      name="newPassword"
      type="password"
      [placeholder]="t('newPasswordPlaceholder')"
      required>

    <input
      [(ngModel)]="confirmPassword"
      name="confirmPassword"
      type="password"
      [placeholder]="t('confirmPasswordPlaceholder')"
      required>

    <button type="submit" [disabled]="loading || !token">
      {{ loading ? t('saving') : t('changePassword') }}
    </button>

    <p class="error-msg" *ngIf="error">{{ error }}</p>

  </form>

  <div class="login-card" *ngIf="done">
    <h2>{{ t('resetDone') }}</h2>
    <p>{{ message }}</p>
    <p>{{ t('redirectingToLogin') }}</p>
  </div>

</div>
